"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../../../Atoms/Text/Text"));
var _HeaderNav = require("./HeaderNav2025.style");
var _MenuGroupIcon = _interopRequireDefault(require("./Menu-Group-Icon.svg"));
var _MoreNav = require("./MoreNav.style");
const MoreNav = _ref => {
  let {
    processedItems,
    openedSubMenu,
    toggleSubMenu,
    navHelper,
    allowListed,
    internalLinkHelper
  } = _ref;
  const handleNestedLinkClick = (e, childID, hasPopUp) => {
    if (hasPopUp) {
      // Toggle the state for this item:
      toggleSubMenu(e, childID);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_MoreNav.MoreNavItem, {
    id: "more-nav"
  }, /*#__PURE__*/_react.default.createElement(_MoreNav.MoreNavLabel
  // Used to target focus/blur handlers
  , {
    id: "more-nav-label"
    // Ensure we can tab to this normally non-foccusable element:
    ,
    tabIndex: "0"
    // Shrug off any click-fire focus events to not mess with other events:
    ,
    onClick: e => e.target.blur(),
    "aria-haspopup": "true"
  }, "More", /*#__PURE__*/_react.default.createElement(_HeaderNav.ChevronWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _MenuGroupIcon.default,
    alt: "Chevron icon"
  }))), /*#__PURE__*/_react.default.createElement(_MoreNav.MoreSubNavMenu, {
    role: "list",
    id: "more-nav-ul",
    key: "more-nav-ul"
  }, processedItems.moreNavGroups.map(child => {
    /* Grab the first links properties to use for our parent/button */
    const thisFirstChild = child.links[0];
    let thisUrl = navHelper(thisFirstChild);
    const relNoopener = !allowListed(thisUrl) && 'noopener' || null;
    const hasSubMenu = child.links && child.links.length > 1;
    const hasPopUp = hasSubMenu ? 'true' : null;
    thisUrl = internalLinkHelper(thisUrl);
    return /*#__PURE__*/_react.default.createElement(_MoreNav.MoreSubNavItem, {
      key: child.title
    }, /*#__PURE__*/_react.default.createElement(_MoreNav.MoreNavNestedLink, {
      href: hasPopUp ? '#' : thisUrl,
      inline: true,
      rel: relNoopener,
      "aria-haspopup": hasPopUp,
      role: hasPopUp ? 'button' : 'link',
      onClick: e => handleNestedLinkClick(e, child.id, hasPopUp),
      isSubMenuOpen: Boolean(openedSubMenu[child.id]),
      "aria-expanded": Boolean(openedSubMenu[child.id])
    }, thisFirstChild.title, hasSubMenu && /*#__PURE__*/_react.default.createElement(_HeaderNav.ChevronWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _MenuGroupIcon.default,
      alt: "Chevron icon"
    }))), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasSubMenu && /*#__PURE__*/_react.default.createElement(_MoreNav.MoreNestedSubNavMenu, {
      role: "list",
      isSubMenuOpen: Boolean(openedSubMenu[child.id])
    }, child.links.map(subChild => {
      let thisSubUrl = navHelper(subChild);
      thisSubUrl = internalLinkHelper(thisSubUrl);
      return (
        /*#__PURE__*/
        // 'More Nav' sub item:
        _react.default.createElement(_MoreNav.MoreNavSubItem, {
          key: thisSubUrl
        }, /*#__PURE__*/_react.default.createElement(_MoreNav.MoreSubNavLink, {
          href: thisSubUrl,
          inline: true,
          role: "menuitem"
          // Allows us to avoid using the 'display:none'
          // approach so we can animate properly:
          ,
          tabIndex: openedSubMenu[child.id] ? '0' : '-1'
        }, /*#__PURE__*/_react.default.createElement(_Text.default, null, subChild.title)))
      );
    }))));
  })));
};
var _default = exports.default = MoreNav;